import * as yup from 'yup';

export const signUpValidation = yup.object().shape({
  email: yup
    .string()
    .required('Please enter you email address')
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter valid email',
    ),
});
export const loginValidation = yup.object().shape({
  email: yup
    .string()
    .required('Please enter you email address')
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter valid email',
    ),
  password: yup
    .string()
    .required('Please enter password.')
    .matches(
      /^(?=.*[A-Z])(?=.*[~!@#$%^&*()/_=+[\]{}|;:,.<>?-])(?=.*[0-9])(?=.*[a-z]).{8,14}$/,
      'Only accept One Uppercase and atleast one special characters and numbers.',
    )
    .min(8, 'Minimum 8 characters is required.'),
  verificationCode: yup.string().required('Please enter OTP'),
});
export const subAdminValidation = yup.object().shape({
  fullname: yup.string().required('Please enter you full name')
    .matches(/^[A-Za-z\s]+$/, 'Special characters are not allowed.')
    .min(3, 'Name must be at least 3 characters long.')
    .max(50, 'Name cannot exceed 50 characters.'),
  email: yup
    .string()
    .required('Please enter you email address')
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter valid email',
    ),
  password: yup
    .string()
    .required('Please enter password.')
    .matches(
      /^(?=.*[A-Z])(?=.*[~!@#$%^&*()/_=+[\]{}|;:,.<>?-])(?=.*[0-9])(?=.*[a-z]).{8,50}$/,
      'Password must have at least one uppercase letter, one special character, and one number.'
    ).min(8, 'Password must be at least 8 characters long.')
    .max(50, 'Password cannot exceed 50 characters.'),
});
export const currencyValidation = yup.object().shape({
  currency: yup.string().required('Required'),
  currentRate: yup.string().required('Required'),
  agentCommission: yup
    .number()
    .positive()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('Required'),
  enhancer: yup
    .number()
    .positive()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('Required'),
  platformFee: yup
    .number()
    .positive()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('Required'),
});
export const userValidation = yup.object({
  fullname: yup.string().required('Full name is required')
    .matches(/^[A-Za-z\s]+$/, 'Full name must only contain letters and spaces.')
    .min(3, 'Full name must be at least 3 characters long.')
    .max(50, 'Full name cannot exceed 50 characters.'),
  email: yup
    .string()
    .required('Email is required')
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter valid email',
    ),
  mobile: yup
    .string()
    .required('Mobile number is required')
    .matches(
      /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      'Please enter only 10 digit number.',
    ),
  city: yup.string().nullable().matches(/^[A-Za-z\s]+$/, 'City name must only contain letters and spaces.')
    .min(2, 'City name must be at least 2 characters long.')
    .max(50, 'City name cannot exceed 50 characters.'),
  country: yup.string().nullable()
    .matches(/^[A-Za-z\s]+$/, 'Country name must only contain letters and spaces.')
    .min(2, 'Country name must be at least 2 characters long.')
    .max(50, 'Country name cannot exceed 50 characters.'),
  whatsapp: yup
    .string()
    .matches(
      /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      'Please enter only 10 digit number.',
    )
    .nullable(),
  telegram: yup.string().nullable()
    .min(3, 'Telegram username must be at least 3 characters long.')
    .max(30, 'Telegram username cannot exceed 30 characters.')
    .matches(
      /^[A-Za-z0-9_]+$/,
      'Telegram username must only contain letters, numbers, and underscores.'
    ),
});
export const partnerValidation = yup.object({
  fullname: yup.string().required('Full name is required')
    .matches(/^[A-Za-z\s]+$/, 'Full name must only contain letters and spaces.')
    .min(3, 'Full name must be at least 3 characters long.')
    .max(50, 'Full name cannot exceed 50 characters.'),
  email: yup
    .string()
    .required('Email is required')
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter valid email',
    ),
  mobile: yup
    .string()
    .required('Mobile number is required')
    .matches(
      /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      'Please enter only 10 digit number.',
    ),
  city: yup.string().required('City is required'),
  country: yup.string().required('Country is required'),
  state: yup.string().required('State is required'),
  timeZone: yup.string().required('TimeZone is required'),
  whatsapp: yup
    .string()
    .matches(
      /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      'Please enter only 10 digit number.',
    )
    .nullable(),
  telegram: yup.string().required('Telegram is required')
    .matches(
      /^[A-Za-z0-9_]+$/,
      'Telegram username must only contain letters, numbers, and underscores.'
    )
    .min(3, 'Telegram username must be at least 3 characters long.')
    .max(30, 'Telegram username cannot exceed 30 characters.'),

});
export const QrCodeValidation = yup.object().shape({
  upi: yup.string().required('Required').matches(/^[\w.-]+@[\w.-]+$/, 'Please enter a valid UPI ID'),
  image: yup.string().required('Required'),
});
export const PurchaseReqValidation = yup.object().shape({
  text: yup.string().required('Required'),
});

const processedValidation = yup.object().shape({
  text: yup.string().required("Name is required"),
});

const rejectedValidation = yup.object().shape({
  text: yup.string()
    .required("Specific reason is required")
    .min(10, "Reason must be at least 10 characters")
    .max(100, "Reason must be at most 100 characters"),
});

const completedValidation = yup.object().shape({
  text: yup.string()
    .required("Transaction hash is required")
    .matches(/^0x[A-Fa-f0-9]{64}$/, "Invalid transaction hash"),
});

// Function to return the appropriate schema
export const getValidationSchema = (statusType) => {
  if (statusType === "Processed") return processedValidation;
  if (statusType === "Rejected") return rejectedValidation;
  if (statusType === "Completed") return completedValidation;
};

export const AssignPartnerValidation = yup.object().shape({
  partnerId: yup.string().required('Required'),
});


export const AccountValidation = yup.object().shape({
  accountHolderName: yup.string().required('Required')
    .matches(/^[A-Za-z\s]+$/, 'Only alphabets are allowed')
    .min(3, 'Name must be at least 3 characters long')
    .max(50, 'Name cannot exceed 50 characters'),
  accountNumber: yup
    .string()
    .required('Required')
    .matches(/^\d{8,18}$/, 'Account number must be 8-18 digits and numeric only'),
  bankName: yup.string().required('Required')
    .matches(/^[A-Za-z\s]+$/, 'Bank name must not contain special characters or numbers') // Only letters and spaces
    .min(3, 'Bank name must be at least 3 characters long') // Minimum length
    .max(50, 'Bank name cannot exceed 50 characters'),
  ifscCode: yup
    .string()
    .required('Required')
    .matches(/^[A-Za-z]{4}[0-9]{7}$/, 'Invalid IFSC code')
    .min(11, 'IFSC code must be exactly 11 characters long')
    .max(11, 'IFSC code must be exactly 11 characters long'),
});

export const merchantValidationSchema = yup.object().shape({
  fullname: yup.string().required('Full name is required')
    .matches(/^[A-Za-z\s]+$/, 'Full name must only contain letters and spaces.')
    .min(3, 'Full name must be at least 3 characters long.')
    .max(50, 'Full name cannot exceed 50 characters.'),
  email: yup
    .string()
    .required('Email is required')
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter valid email',
    ),
  websiteDomain: yup.string().required('Website Domain is required')
    .matches(
      /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
      'Please enter a valid website domain.'
    )
    .min(5, 'Website domain must be at least 5 characters long.')
    .max(100, 'Website domain cannot exceed 100 characters.'),

  platformName: yup.string().required('Platform Name is required')
    .matches(/^[A-Za-z\s]+$/, 'Platform name must only contain letters and spaces.')
    .min(3, 'Platform name must be at least 3 characters long.')
    .max(50, 'Platform name cannot exceed 50 characters.'),

  callbackUrl: yup.string().required('Call Back Url is required')
    .matches(
      /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
      'Please enter a valid callback URL.'
    ),
  uin: yup.string().required('uin is required')
    .matches(/^\d{12}$/, 'UIN must be a 12-digit number.'),
  walletAddress: yup.string().required('Wallet Address is required')
    .matches(/^0x[a-fA-F0-9]{40}$/, 'Wallet address must be a valid 42-character Ethereum address.'),
  howToFind: yup.string().required('How to find is required')
    .max(500, 'Response cannot exceed 500 characters.'),

});
